import { STATUS_ACTIVE } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import {
  DefaultResponse,
  InstitutionProp,
  UserResponse,
} from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const FILTER_MANAGEMENT_URL = '/ris/filters/v1';

interface ParamsGetFilterManagement {
  created_at_from?: string;
  created_at_to?: string;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  offset?: number;
  sort_field?:
    | ''
    | 'name'
    | 'type'
    | 'status'
    | 'created_at'
    | 'updated_at'
    | 'institution_id';
  sort_order?: SORT_ORDER;
  status?: typeof STATUS_ACTIVE[keyof typeof STATUS_ACTIVE];
  // type?: 0 | 1; // 0: CONDITIONAL, 1: UNCONDITIONAL
  updated_at_from?: string;
  updated_at_to?: string;
}
export interface ResponseGetFilterManagement extends DefaultResponse {
  data: {
    condition: string;
    created_at: string;
    desc: string;
    group: string;
    id: string;
    institution: InstitutionProp;
    institution_id: string;
    name: string;
    status: boolean;
    type: number;
    updated_at: string;
    user: UserResponse;
    user_id: string;
  }[];
}
export const getFiltersManagement = async (
  params: ParamsGetFilterManagement = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: FILTER_MANAGEMENT_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetFilterManagement>;

  return response.data;
};
export interface ResponseGetFilterManagementTree
  extends Omit<DefaultResponse, 'count'> {
  data: {
    institution_id: string;
    institution_name: string;
    filters?: null | ResponseGetFilterManagementTree['data'];
  }[];
}
export const getFiltersTree = async () => {
  const response = (await api({
    url: `${FILTER_MANAGEMENT_URL}/tree`,
    method: 'GET',
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetFilterManagementTree>;

  return response.data;
};
export interface ParamsCreateFilterManagement {
  institution_id: string;
  name: string;
  type: number;
  group?: string;
  status: boolean;
  desc: string;
  condition?: {
    device?: string[];
    match_status?: number[];
    modality?: string[];
    source_aetitle?: string[];
    studylist_status?: number[];
  };
}
export const createFilterManagement = async (
  data: ParamsCreateFilterManagement
) => {
  const response = (await api({
    url: FILTER_MANAGEMENT_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const updateFilterManagement = async (
  id: string,
  data: Omit<ParamsCreateFilterManagement, 'institution_id'>
) => {
  const response = (await api({
    url: `${FILTER_MANAGEMENT_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteFilterManagement = async (id: string) => {
  return (await api({
    url: `${FILTER_MANAGEMENT_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;
};
